var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.formattedValue && _vm.value)?_c('v-breadcrumbs-item',{staticClass:"slash",attrs:{"append":"","disabled":_vm.disabled,"exact":"","to":_vm.toRoute}},[_vm._v(_vm._s(_vm._f("titleCase")(_vm.value)))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }